import _get from 'lodash/get';
import { EHomeworkType, ELiveType, EMEETING_STATUS, EMediaStatusStyleType, LiveStatus, PARTICIPATE_STATUS, RESOURCE_MEDIA_TYPE, SESSION_TYPE } from "./enum";
import { MediaSessionTypeList, SessionItemInfoOptions, SupportSubmissionTimeTypeList } from "./constant";
import { IElement } from './api';
import { lang } from '@umu/ukit-lang';
import { formatTimeStamp, isThisYear } from './util';

export const getMediaResource = (session: IElement, reourceType: RESOURCE_MEDIA_TYPE) => {
  const { resource_arr } = session;
  return resource_arr.find(item => item.resource_type === reourceType);
};

export const HomeworkTypeNameMap = {
  [EHomeworkType.AUDIO]: lang('语音作业'),
  [EHomeworkType.VIDEO]: lang('视频作业'),
  [EHomeworkType.IMGTXT]: lang('图文作业'),
  [EHomeworkType.DOC]: lang('文档作业'),
  [EHomeworkType.GESTURE]: lang('动作练习'),
};

/** 获取多媒体小节,会议小节状态标签 */
export const getMediaSessionStatusInfo = (session: IElement) => {
  let label = '';
  let styleType = EMediaStatusStyleType.DEFAULT;

  const { type, setup: { live_type } } = session;
  if (!MediaSessionTypeList.includes(type) && type !== SESSION_TYPE.MEETING) {
    return {
      label, styleType
    };
  }
  if (type == SESSION_TYPE.LIVE || type == SESSION_TYPE.LIVE_PRO) {
    const resource = getMediaResource(session, RESOURCE_MEDIA_TYPE.TYPE_LIVE);
    const liveStatus = _get(resource, 'resource_info.live_session_status');
    if (liveStatus === LiveStatus.STATUS_READY || !liveStatus) {
      label = lang('尚未开始');
      styleType = EMediaStatusStyleType.DEFAULT;
    } else if (liveStatus === LiveStatus.STATUS_ONGOING) {
      label = lang('进行中');
      styleType = EMediaStatusStyleType.RED;
    } else {
      const isAudioLive = live_type == ELiveType.AUDIO_ONLY;
      if (isAudioLive) {
        label = lang('回放');
      }
    }
  } else if (type == SESSION_TYPE.VIDEO) {
    const resource = getMediaResource(session, RESOURCE_MEDIA_TYPE.TYPE_VIDEO);
    const videoStatus = _get(resource, 'resource_info.status');
    if (videoStatus == 'wait_transcoding') {
      label = lang('视频处理中，请稍后查看');
      styleType = EMediaStatusStyleType.RED;
    }
  } else if (type == SESSION_TYPE.MEETING) {
    const resource = getMediaResource(session, RESOURCE_MEDIA_TYPE.TYPE_MEETTING);
    const meetingStatus = _get(resource, 'resource_info.status', EMEETING_STATUS.NOT_STARTED);
    if (meetingStatus == EMEETING_STATUS.NOT_STARTED) {
      label = lang('尚未开始');
      styleType = EMediaStatusStyleType.DEFAULT;
    } else if (meetingStatus == EMEETING_STATUS.ONGOING) {
      label = lang('进行中');
      styleType = EMediaStatusStyleType.RED;
    } else {
      label = lang('已结束');
      styleType = EMediaStatusStyleType.DEFAULT;
    }
  }
  return {
    label, styleType
  };

};

export const getSessionTypeName = (session: IElement) => {
  const { type, setup: { type_name, homework_type } } = session;
  const { text } = SessionItemInfoOptions[type];
  if (type_name) {
    return type_name;
  }
  if (homework_type) {
    return HomeworkTypeNameMap[homework_type];
  }
  return text;
};

/**
 * 获取小节提交时间
 */
export const getSubmissionTimeTips = (session: IElement) => {
  const { participate_info, type } = session;
  if (!participate_info) {
    return '';
  }
  if (!SupportSubmissionTimeTypeList.includes(type)) {
    return '';
  }

  const { accept_submission_time, refuse_submission_time, participate_status } = participate_info;

  function formatTime(time: number) {
    const format = isThisYear(time) ? 'MM-DD HH:mm' : 'YYYY-MM-DD HH:mm';
    return formatTimeStamp(time, format);
  }

  if (participate_status === PARTICIPATE_STATUS.ONSTART && +accept_submission_time !== 0) {
    const time = formatTime(accept_submission_time);
    return time + ' ' + lang('开始提交');
  }
  if (participate_status === PARTICIPATE_STATUS.PENDING && +refuse_submission_time !== 0) {
    const time = formatTime(refuse_submission_time);
    return time + ' ' + lang('结束提交');
  }
  if (participate_status === PARTICIPATE_STATUS.ONEND) {
    return lang('已结束提交');
  }
  return '';
};
